import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const StoreStatusContext = createContext(null);

export function StoreStatusProvider({ children }) {
  const [storeStatus, setStoreStatus] = useState(null);       // {is_open, closed_message, ...}
  const [launchPromo, setLaunchPromo] = useState(null);       // {is_active, remaining, limit, used, product}
  const [storeMode, setStoreMode] = useState(null);           // {live: bool}
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const [s, p, m] = await Promise.all([
        api.get("/config/store-status"),
        api.get("/config/launch-promo"),
        api.get("/config/store-mode"),
      ]);
      setStoreStatus(s.data);
      setLaunchPromo(p.data);
      setStoreMode(m.data);
    } catch (_) {
      // Fail open — never brick the UI when the config endpoints hiccup.
      setStoreStatus((prev) => prev || { is_open: true, closed_message: "" });
      setStoreMode((prev) => prev || { live: true });
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
    // Refresh every 5 minutes so the Monday flip-over and admin toggles
    // propagate to already-open tabs without a manual reload.
    const t = setInterval(refresh, 5 * 60 * 1000);
    return () => clearInterval(t);
  }, [refresh]);

  return (
    <StoreStatusContext.Provider value={{ storeStatus, launchPromo, storeMode, loading, refresh }}>
      {children}
    </StoreStatusContext.Provider>
  );
}

export const useStoreStatus = () => useContext(StoreStatusContext) || {};
